import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import type { DataTableFilterMeta } from 'primevue/datatable';
import { FilterMatchMode } from '@primevue/core/api';

const defaultFilters: DataTableFilterMeta = {
  id: { value: null, matchMode: FilterMatchMode.CONTAINS },
  description: { value: null, matchMode: FilterMatchMode.CONTAINS },
  campaignStatus: { value: null, matchMode: FilterMatchMode.IN },
  status: { value: null, matchMode: FilterMatchMode.IN },
  esignStatus: { value: null, matchMode: FilterMatchMode.IN },
  entityName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  entityId: { value: null, matchMode: FilterMatchMode.CONTAINS },
  type: { value: null, matchMode: FilterMatchMode.IN },
  campaignFocus: { value: null, matchMode: FilterMatchMode.CONTAINS },
  campaignName: { value: null, matchMode: FilterMatchMode.CONTAINS },
  age: { value: null, matchMode: FilterMatchMode.CONTAINS },
  created: { value: null, matchMode: FilterMatchMode.CONTAINS },
  modified: { value: null, matchMode: FilterMatchMode.CONTAINS },
  customerViewed: { value: null, matchMode: FilterMatchMode.CONTAINS },
  ownerName: { value: null, matchMode: FilterMatchMode.IN },
};

export const useDocumentStore = defineStore('document-store', () => {
  const documents = ref<any[]>([]);
  const documentStatuses = ref<string[]>([]);
  const isLoading = ref(false);

  const showFilters = ref(true);
  const filteredDocumentLength = ref<number>();
  const selectedDocument = ref();

  const tableFilters = ref<DataTableFilterMeta>({ ...defaultFilters });
  const previousTableFilters = ref<DataTableFilterMeta>();

  const resetTableFilters = () => tableFilters.value = { ...defaultFilters };

  const isFilterChanged = computed<boolean>(() => JSON.stringify(tableFilters.value) !== JSON.stringify(defaultFilters));

  const hideTableFilters = () => {
    const activeFilter = JSON.stringify(tableFilters.value);
    const defaultFilter = JSON.stringify(defaultFilters);

    if (activeFilter !== defaultFilter) {
      previousTableFilters.value = { ...tableFilters.value };
    }
    tableFilters.value = undefined;
  };

  const showTableFilters = () => {
    if (previousTableFilters.value) {
      tableFilters.value = { ...previousTableFilters.value };
      previousTableFilters.value = undefined;
    } else {
      resetTableFilters();
    }
  };

  return {
    documents,
    documentStatuses,
    filteredDocumentLength,
    hideTableFilters,
    isFilterChanged,
    isLoading,
    resetTableFilters,
    selectedDocument,
    showFilters,
    showTableFilters,
    tableFilters,
  };
});
